import type { UserContextViewModel } from 'autogen/swagger/all';

const userContextObj: UserContextViewModel = {
    isAuthenticated: false,
    isClubMatasMember: false,
    isGa4Debug: false,
    isMatasPlusMember: false,
    loginDirectLink: {},
    permissionRequired: false,
    splitTestAssignments: [],
    userHasSeenProductPage: false,
    voyadoMemberLevel: 'Silver',
    userHasMatasPlusSignupInBasket: false
};

export const setUserContext = (obj): void => {
    Object.entries(obj).forEach(([key, item]) => {
        userContextObj[key] = item;
    });
};

const UserContext = (): UserContextViewModel => userContextObj;

export default UserContext();
